@if (enableAdCarousel()) {
  <div class="carousel-container" [class.hmf-mt-s]="hasTopMargin()">
    <div class="carousel-slides">
      <div class="carousel-slide evergreen-carousel-slide"
        [class.active]="currentSlide() === 0"
        [attr.tabindex]="currentSlide() === 0 ? 0 : -1">
        @if (templateData()) {
          <shared-components-evergreen-template
            [templateData]="templateData()"
            [isNarrowTemplate]="isNarrowBanner()"
            [pageType]="pageType()">
          </shared-components-evergreen-template>
        }
      </div>
      <div class="carousel-slide" [class.active]="currentSlide() === 1">
        <div
          [id]="data()"
          class="google-ad-container hmf-display-block hmf-mx-auto hmf-mb-0"
          >
        </div>
      </div>
    </div>
    <div class="carousel-controls hmf-display-flex hmf-mb-xs hmf-justify-content-between" [class.active]="currentSlide() === 1 || shouldShowSponsoredLabel()">
      <div class="carousel-button-container-wrapper hmf-display-flex hmf-justify-content-center hmf-position-absolute">
        <button
          class="carousel-button-container hmf-display-flex hmf-justify-content-center hmf-align-content-center"
          [class.active]="currentSlide() === 0"
          [attr.aria-pressed]="currentSlide() === 0"
          tabindex="0"
          (click)="currentSlide.set(0)"
          (keyup.enter)="currentSlide.set(0)"
          (keyup.space)="currentSlide.set(0)">
          <homefield-icon class="carousel-button" [height]="currentSlide() === 0 ? '10px' : '8px'" [width]="currentSlide() === 0 ? '10px' : '8px'" name="fulfillment-availability-fill" [fill]="currentSlide() === 0 ? 'var(--hmf-fill-positive)' : 'var(--hmf-fill-base-prominent)'"></homefield-icon>
        </button>
        <button
          class="carousel-button-container hmf-display-flex hmf-justify-content-center hmf-align-content-center"
          [class.active]="currentSlide() === 1"
          [attr.aria-pressed]="currentSlide() === 1"
          tabindex="0"
          (click)="currentSlide.set(1)"
          (keyup.enter)="currentSlide.set(1)"
          (keyup.space)="currentSlide.set(1)">
          <homefield-icon class="carousel-button" [height]="currentSlide() === 1 ? '10px' : '8px'" [width]="currentSlide() === 1 ? '10px' : '8px'" name="fulfillment-availability-fill" [fill]="currentSlide() === 1 ? 'var(--hmf-fill-positive)' : 'var(--hmf-fill-base-prominent)'"></homefield-icon>
        </button>
      </div>
      <div
        class="hmf-ml-auto"
        id="carouselSponsoredLabel"
        [class.active]="currentSlide() === 1"
        [class.dsg-store-sponsored-tag]="isDsgStorePage">
        <button
          id="sponsoredButton"
          class="sponsored-button hmf-p-0"
          (click)="loadSurvey()">
          <div class="sponsored-text hmf-display-flex hmf-align-items-center">
            Sponsored
            @if (enableTooltipSurvey()) {
              <div class="icon-container hmf-display-flex hmf-align-items-center hmf-justify-content-center">
                <homefield-icon width="14px" height="16px" fill="var(--hmf-label-base-subtle)" name="alert-info-outline" />
              </div>
              }
          </div>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div
    [id]="data()"
    class="google-ad-container hmf-display-block hmf-mx-auto hmf-mb-0"
    [class.hmf-mt-s]="hasTopMargin()">
  </div>
  @if (shouldShowSponsoredLabel()) {
    <div
      class="hmf-display-flex hmf-justify-content-end hmf-mb-s hmf-ml-auto"
      id="sponsoredLabel"
      [class.top-placement]="isTopPlacement()"
      [class.dsg-store-sponsored-tag]="isDsgStorePage">
      <button
        id="sponsoredButton"
        class="sponsored-button hmf-p-0"
        (click)="loadSurvey()">
        <div class="sponsored-text hmf-display-flex hmf-align-items-center">
          Sponsored
          @if (enableTooltipSurvey()) {
          <div class="icon-container hmf-display-flex hmf-align-items-center hmf-justify-content-center">
            <homefield-icon
              width="14px"
              height="16px"
              fill="var(--hmf-label-base-subtle)"
              name="alert-info-outline"/>
          </div>
          }
        </div>
        
      </button>
    </div>
  }
}